import { render, staticRenderFns } from "./M_index.vue?vue&type=template&id=65a01cf6&scoped=true&"
import script from "./M_index.vue?vue&type=script&lang=js&"
export * from "./M_index.vue?vue&type=script&lang=js&"
import style0 from "./M_index.vue?vue&type=style&index=0&id=65a01cf6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a01cf6",
  null
  
)

export default component.exports